import { StoreBadges } from "./StoreBadges";

const AppStoreBanner = () => {
  return (
    <div className="border-b border-border bg-gradient-to-r from-primary/10 via-secondary/10 to-primary/10">
      <div className="container mx-auto px-6 py-3">
        <div className="flex flex-col items-center justify-center gap-4 text-center sm:flex-row">
          <p className="text-sm font-medium text-foreground">Get the PROduce Crew app</p>
          <StoreBadges />
        </div>
      </div>
    </div>
  );
};

export default AppStoreBanner;
